const getters = {
  permission_routes: state => state.permission.routes
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js